import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { CreateDocumentSignerPresignedUrlForUploadRequest, CreatePresignedUrlForUploadResponse } from "@maven-rest/docs/S3.dto";
import { S3Rest } from "@maven-rest/docs/s3.rest";

export function useCreateDocumentSignerPresignedUrlForUpload(req: {
  onSuccess: (
    data: CreatePresignedUrlForUploadResponse,
    variables: CreateDocumentSignerPresignedUrlForUploadRequest,
    context: unknown
  ) => void;
  onError: (
    error: RestError<CreatePresignedUrlForUploadResponse>,
    variables: CreateDocumentSignerPresignedUrlForUploadRequest,
    context: unknown
  ) => void;
}) {
  return useBaseMutation({
    mutationFn: async (request: CreateDocumentSignerPresignedUrlForUploadRequest) => {
      return await S3Rest.createDocumentSignerPresignedUrlForUpload(request);
    },
    onSuccess: req.onSuccess,
    onError: req.onError,
  });
}
